import { useLayoutEffect, useMemo, useRef } from "react"
import { getState, setUi, useStore } from "../store/store"
import { threadMessages } from "../store/visible"
import { Composer } from "./Composer"
import { MessageRow } from "./MessageRow"

export function ThreadPane({ rootId }: { rootId: string }) {
	const root = useStore(s => s.messages[rootId])
	const messages = useStore(s => s.messages)
	const loaded = useStore(s => !!s.threadsLoaded[rootId])
	const replies = useMemo(() => threadMessages(getState(), rootId), [messages, rootId])
	const list = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
		const el = list.current
		if (el) el.scrollTop = el.scrollHeight
	}, [replies.length])

	const open =
		root?.request && (root.request.status === "open" || root.request.status === "claimed")

	return (
		<section className="thread" aria-label="Thread">
			<header className="conv-h">
				<span className="conv-title">Thread</span>
				<span className="dim">
					{root ? `${replies.length} ${replies.length === 1 ? "reply" : "replies"}` : ""}
					{!loaded && " · loading"}
				</span>
				<div className="filters">
					<button
						className="icon-btn"
						aria-label="Close thread (Esc)"
						title="Close (Esc)"
						onClick={() => setUi({ threadId: null })}
					>
						×
					</button>
				</div>
			</header>
			<div ref={list} className="list" role="listbox" aria-label="Thread messages">
				{root ? (
					<div className="thread-root">
						<MessageRow m={root} selected={false} inThread />
					</div>
				) : (
					<div className="empty">Loading…</div>
				)}
				{replies.map(m => (
					<MessageRow key={m.id} m={m} selected={false} inThread />
				))}
			</div>
			<Composer
				target="thread"
				roomId={root?.roomId ?? null}
				replyTo={rootId}
				placeholder="Reply in thread"
				resolvable={!!open}
			/>
		</section>
	)
}
